/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChanges,
} from '@angular/core';
import { Subject } from 'rxjs';
import { TicketContext } from 'src/app/modules/ticket-edit-panel/ticket-context';
import { AttachedFilesService } from '../../attached-files.service';
import { AttachmentsViewState } from '../../attachments-view-state';

@Component({
	selector: 'attached-images',
	templateUrl: './attached-images.component.html',
	styleUrls: ['./attached-images.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [AttachedFilesService],
})
export class AttachedImagesComponent implements OnInit, OnChanges, OnDestroy {
	@Input() public ticketContext: TicketContext;

	@Input() public ticketId: string;

	// get ref to enum for template
	public attachmentsViewState = AttachmentsViewState;

	private shutdownSubject$ = new Subject<void>();

	constructor(public attachedFilesService: AttachedFilesService) {}

	public ngOnInit(): void {
		this.attachedFilesService.setTicketContext(this.ticketContext);
	}

	public ngOnChanges(changes: SimpleChanges): void {
		const ticketIdChange = changes.ticketId;
		if (ticketIdChange?.currentValue && ticketIdChange.previousValue !== ticketIdChange.currentValue) {
			this.attachedFilesService.createApi(
				this.ticketContext.projectId,
				this.ticketContext.userId,
				ticketIdChange.currentValue,
				this.ticketContext.planId
			);
			this.attachedFilesService.updateThumbnailFileUrls();
		}
	}

	public ngOnDestroy(): void {
		this.shutdownSubject$.next();
		this.shutdownSubject$.complete();
	}
}
